import { createContext } from 'react';

export interface SharedTestIdProps {
  sharedId: string;
}

export const SharedTestIdContext = createContext<SharedTestIdProps>({} as SharedTestIdProps);
